import React from 'react';
import GameLobby from '../components/GameLobby';
import Leaderboard from '../components/Leaderboard';
import GameHistory from '../components/GameHistory';

function GamePage() {
  const token = localStorage.getItem('memo_token');
  const user = JSON.parse(localStorage.getItem('memo_user') || '{}');
  
  if (!token) {
    window.location.href = '/login';
    return null;
  }
  
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg-secondary)' }}>
      <div className="container" style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}>
        <GameLobby token={token} user={user} />
        <Leaderboard />
        <GameHistory />
      </div>
    </div>
  );
}

export default GamePage;